import dayjs from 'dayjs';
import React from 'react';

import CHorizontalScrollContainer from '../../../components/CHorizontalScrollContainer';
import CLocalizedText from '../../../components/CLocalizedText';
import CPageModule from '../../../components/CPageModule';
import CPageModulePlot from '../../../components/CPageModulePlot';
import CPandasTable from '../../../components/CPandasTable';
import CStatefulContainer from '../../../components/CStatefulContainer';
import GenericDateRangeSelector from '../../../components/GenericDateRangeSelector';
import { type IResponse } from '../../../models/IResponse';
import { type PlotlyResponse } from '../../../models/PlotlyModel';
import { type TPandasTable } from '../../../models/TPandasTable';
import { type ISectorPerformanceParameters } from '../../../models/ISectorPerformanceParameters';

interface Props {
  initialEndDate: string;
  initialStartDate: string;
  sectorDistributionPlot: IResponse<PlotlyResponse>;
  sectorDistributionTable: IResponse<TPandasTable>;
  onParamChange: (updated: Partial<ISectorPerformanceParameters>) => void;
  parameters: ISectorPerformanceParameters;
  minDate: string;
  maxDate: string;
}

export default function CSectorDistribution(props: Props) {
  return (
    <CPageModule fullWidth>
      <CPageModule submodule>
        <h3>
          <CLocalizedText dictKey={'sectorPerformance.sectorDistribution.title'} />
        </h3>
        <p>
          <CLocalizedText dictKey={'sectorPerformance.sectorDistribution.description'} />
        </p>
      </CPageModule>
        <>
          <CStatefulContainer
            submodule
            apiRequestState={props.sectorDistributionPlot.state}
            showContent={!!props.sectorDistributionPlot.data}
          >
            <CPageModulePlot
              data={props.sectorDistributionPlot.data?.data}
              layout={props.sectorDistributionPlot.data?.layout}
            />
          </CStatefulContainer>
        </>
      {!!props.sectorDistributionPlot?.data &&
        <>
          {!!props.sectorDistributionTable?.data &&
            <CPageModule submodule>
              <div className="flex justify-end">
                <GenericDateRangeSelector
                  minDate={dayjs(props.minDate).valueOf()}
                  maxDate={dayjs(props.maxDate).valueOf()}
                  initStartDate={dayjs(props.initialStartDate).valueOf()}
                  initEndDate={dayjs(props.initialEndDate).valueOf()}
                  inlineScroll
                  onlyEndDate
                  onChangeDeprecate={({ end }) => {
                    props.onParamChange({ tableDate: dayjs(end).format('YYYY-MM-DD') });
                  }}
                />
              </div>
            </CPageModule>
        }
          <CStatefulContainer
            submodule
            apiRequestState={props.sectorDistributionTable.state}
            showContent={!!props.sectorDistributionTable.data}
          >
            <CHorizontalScrollContainer>
              <CPandasTable
                data={props.sectorDistributionTable.data}
                colSpanArr={[1, ...Array(Math.max(0, Object.keys(props.sectorDistributionTable?.data ?? {}).length)).fill(1)]}
                colAlignmentArr={['left', ...Array(Math.max(0, Object.keys(props.sectorDistributionTable?.data ?? {}).length)).fill('right')]}
                showIndex
              />
            </CHorizontalScrollContainer>
          </CStatefulContainer>
        </>
      }
    </CPageModule>
  );
}